var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container collectHome" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: { headerList: [{ label: "我的收藏" }] }
          })
        ],
        1
      ),
      _c("div", { staticClass: "collectHome-content" }, [
        _c("div", { staticClass: "collectHome-content-top" }, [
          _c("div", { staticClass: "collectHome-content-top-left" }, [
            _vm._v(" 我的收藏夹 ")
          ]),
          _c(
            "div",
            {
              staticClass: "collectHome-content-top-right",
              on: { click: _vm.createCollect }
            },
            [
              _c("collect-add-icon", {
                staticStyle: { "margin-right": "4px" }
              }),
              _vm._v(" 新建收藏夹 ")
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "collectHome-content-bottom" },
          [
            _vm._l(_vm.collectList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "collectHome-content-bottom-item",
                  on: {
                    click: function($event) {
                      return _vm.toItem(item)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "collectHome-content-bottom-item-title" },
                    [_vm._v(_vm._s(item.favoriteName))]
                  ),
                  _c(
                    "p",
                    { staticClass: "collectHome-content-bottom-item-desc" },
                    [_vm._v(_vm._s(item.favoriteDesc))]
                  ),
                  _c(
                    "div",
                    { staticClass: "collectHome-content-bottom-item-option" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "collectHome-content-bottom-item-option-time"
                        },
                        [
                          _vm._v(
                            _vm._s(item.updatedTime) +
                              " " +
                              _vm._s(item.total || 0) +
                              "条内容"
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "collectHome-content-bottom-item-option-edit",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.editCollectDialog(item)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass:
                              "collectHome-content-bottom-item-option-edit-img",
                            attrs: { src: require("@/assets/editGray.png") }
                          }),
                          _vm._v("编辑")
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "collectHome-content-bottom-item-option-delete",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.delCollect(item)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: {
                              "font-size": "14px",
                              "margin-right": "2px"
                            }
                          }),
                          _vm._v("删除")
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            _c("div", { staticClass: "footer-page" }, [
              _c(
                "div",
                { staticClass: "footer-right" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                      "current-page": _vm.pageNum,
                      "page-sizes": [10, 20, 50, 100, 1000, 2000],
                      "hide-on-single-page": false
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.pageNum = $event
                      },
                      "update:current-page": function($event) {
                        _vm.pageNum = $event
                      },
                      "current-change": _vm.currentChange,
                      "size-change": _vm.sizeChange
                    }
                  })
                ],
                1
              )
            ])
          ],
          2
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "550px",
            height: "400px",
            title: _vm.title,
            visible: _vm.ifShowEditDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowEditDialog = $event
            }
          }
        },
        [
          _c("collect-edit-dialog", {
            attrs: {
              "if-edit-collect": _vm.ifEditCollect,
              "collect-item": _vm.editCollect
            },
            on: { submitCollectFn: _vm.submitCollectFn }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "600px",
            height: "400px",
            title: "删除收藏夹",
            visible: _vm.ifShowDelDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowDelDialog = $event
            }
          }
        },
        [
          _c("collect-del-dialog", {
            attrs: { "favorites-id": _vm.delFavoritesId },
            on: { delCollectFn: _vm.delCollectFn }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }